import React from 'react';
import { KeycloakProvider } from '@react-keycloak/web';
// Wrap everything inside KeycloakProvider
export var KeycloakComponent = function (options) { return (React.createElement(KeycloakProvider, { keycloak: options.keycloak, onEvent: options.onEvent, onTokens: options.onTokens, initConfig: options.initConfig }, options.children)); };
//# sourceMappingURL=KeycloakComponent.js.map